import React, { Fragment, useEffect, useState } from "react";
import M from "materialize-css";
import Swal from "sweetalert2";

import useStorage from "../../Hooks/useStorage";
import { useAuth } from "../../Context/Context";

import SideNav from "../../Components/SideNav";
import FormularioAgregar from "../../Components/FormularioAgregar";
import View from "./View";

import blogHelper from "../../Helpers/Blogs";
import etiquetasBlogHelper from "../../Helpers/EtiquetasBlogs";
import autoresHelper from "../../Helpers/AutoresBlogs";

// posicion de array de imagenes del blog
// 0 => principal
// 1 => secundaria

const Profesores = (props) => {
  const { editar, setEditar, index, data, setData, tipo } = useAuth();

  const [instance, setInstance] = useState({});

  const [blogs, setBlogs] = useState({
    archivo: "archivo",
    archivoSecundario: "archivo",
    etiquetas: [],
    licenciatura: 1,
    ...editar,
  });
  const [descripcion, setDescripcion] = useState("");
  const [etiquetas, setEtiquetas] = useState([]);
  const [autores, setAutores] = useState([]);
  const [files, setFiles] = useState([]);

  // uso de hooks para agregar imagen a google storage
  const [consulta, setConsulta] = useState("");
  let [response] = useStorage(consulta);

  useEffect(() => {
    if (!response) {
      setBlogs({
        ...blogs,
        ...editar,
      });

      setDescripcion(blogs.descripcion);

      obtenerAutores();
    } else {
      if (response.action === "agregarRecursivo") {
        agregar(response.data);
      } else {
        // error
      }
    }
  }, [response, editar]);

  const obtenerAutores = async () => {
    let res = await autoresHelper.obtnenreAutores();

    if (res.success) {
      setAutores(res.data);

      obtenerEtiquetas();
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar el evento, codigo: " + res.code,
        "error"
      );
    }
  };

  const obtenerEtiquetas = async () => {
    let res = await etiquetasBlogHelper.obtenerEtiquetas();

    if (res.success) {
      setEtiquetas(res.data);

      setTimeout(() => {
        let elems = document.querySelectorAll("select");
        let instance = M.FormSelect.init(elems);

        setInstance(instance);
      }, 200);
    } else {
      Swal.fire(
        "Error!",
        "No se pudo guardar el evento, codigo: " + res.code,
        "error"
      );
    }
  };

  const leerDato = (e) => {
    setBlogs({
      ...blogs,
      [e.target.name]: e.target.value,
    });
  };

  const leerOpciones = (e) => {
    e.preventDefault();

    setBlogs({
      ...blogs,
      [e.target.name]: instance[0].getSelectedValues(),
    });
  };

  const agregarFoto = (e, index) => {
    let fileTempo = [...files];
    fileTempo[index] = e.target.files[0];
    setFiles(fileTempo);

    // visualizar la imagen
    let fileReader = new FileReader();
    fileReader.addEventListener("load", function (evt) {
      setEditar({
        ...editar,
        [e.target.name]: fileReader.result,
      });
    });
    fileReader.readAsDataURL(e.target.files[0]);
  };

  const subirArchivo = (e) => {
    e.preventDefault();

    setConsulta({
      consulta: "agregarRecursivo",
      name: blogs.titulo,
      folder: "blogs/",
      filesJSON: { files },
      url: "/blogs",
    });
  };

  const agregar = (url) => {
    let body = {
      ...editar,
      ...blogs,
      imagen: url[0],
      imagenExterna: url[1],
    };

    blogHelper.agregarBlog(body);
  };

  return (
    <Fragment>
      <SideNav />
      <div className="row">
        <FormularioAgregar>
          <p className="titulo_1_admin">Blogs</p>

          <form onSubmit={subirArchivo}>
            <img alt="imagen Principal" width="100%" src={blogs.archivo}></img>
            <div class="file-field input-field">
              <div class="btn">
                <span>File</span>
                <input
                  name="archivo"
                  onChange={(e) => {
                    agregarFoto(e, 0);
                  }}
                  type="file"
                />
              </div>
              <div class="file-path-wrapper">
                <input
                  name="archivo"
                  class="file-path validate"
                  type="text"
                  placeholder="Imagen Principal"
                />
              </div>
            </div>

            <img
              alt="imagen secundaria"
              width="100%"
              src={blogs.archivoSecundario}
            ></img>
            <div class="file-field input-field">
              <div class="btn">
                <span>File</span>
                <input
                  name="archivoSecundario"
                  onChange={(e) => {
                    agregarFoto(e, 1);
                  }}
                  type="file"
                />
              </div>
              <div class="file-path-wrapper">
                <input
                  name="archivoSecundario"
                  class="file-path validate"
                  type="text"
                  placeholder="Imagen Secundaria"
                />
              </div>
            </div>

            <div className="input-field">
              <input
                onChange={leerDato}
                id="titulo"
                name="titulo"
                type="text"
                className="validate"
              />
              <label for="titulo">Titulo</label>
            </div>
            <div className="input-field">
              <input
                onChange={leerDato}
                id="url"
                name="url"
                type="text"
                className="validate"
              />
              <label for="url">URL</label>
            </div>

            <div class="input-field col s12">
              <select name="etiquetas" multiple onChange={leerOpciones}>
                {etiquetas.map((etiqueta) => (
                  <option value={etiqueta._id}>{etiqueta.nombre}</option>
                ))}
              </select>
              <label>Etiquetas</label>
            </div>

            <div class="input-field col s12">
              <select name="autor" onChange={leerDato}>
                <option value="" disabled selected>
                  Selecciona un autor
                </option>
                {autores.map((autor) => (
                  <option value={autor._id}>{autor.nombre}</option>
                ))}
              </select>
              <label>Autores</label>
            </div>

            <div class="input-field col s12">
              <select name="licenciatura" onChange={leerDato}>
                <option value="" disabled selected>
                  Selecciona una Licenciatura
                </option>
                <option value={0}>Cine Digital</option>
                <option value={1}>Multimedia</option>
                <option value={2}>Marketing</option>
                <option value={3}>Animación</option>
                <option value={4}>Cultura general</option>
              </select>
              <label>Licenciaturas</label>
            </div>

            <div id="ckedittor_contenedor">
              <p>Descripcion</p>
            </div>

            <div className="botonn_1_admin" style={{ marginTop: "10px" }}>
              <button type="submit">Agregar blog</button>
            </div>
          </form>
        </FormularioAgregar>
        <View />
      </div>
    </Fragment>
  );
};

export default Profesores;
